/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import NewsletterSubscription from '../components/react/newsletter_subscription/newsletter_subscription';
import 'bootstrap/js/dist/tooltip';
import './vertical.scss';

/* eslint-enable max-len */

const LandingPagesVertical = ({ newsletter, isSignedIn = false }) => {
  return (
    <NewsletterSubscription
      newsletter={newsletter}
      isSignedIn={isSignedIn}
      buttonClass='subscribe-button-ua-with-icon'
    />
  );
};

LandingPagesVertical.propTypes = {
  newsletter: PropTypes.shape({
    id: PropTypes.number.isRequired,
    permalink: PropTypes.string.isRequired,
    icon: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    accent_color: PropTypes.string,
  }),
  isSignedIn: PropTypes.bool,
};

export default LandingPagesVertical;
